import React, { Component } from 'react';
import { Jumbotron, Container } from 'reactstrap';

import { FeaturedPrograms } from './FeaturedPrograms.js'
import { Events } from './Events.js'

// My page (organization)
export class MyOrgPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {

    // log out users automatically after refreshing, this text prompts users to log in
    if (!this.props.logInMember & !this.props.logInOrg) {
      return (
        <Jumbotron fluid className="p-5 mb-0">
          <Container fluid>
            <h1 className="display-3 kurb-bd">Sorry, please sign up or log in first</h1>
          </Container>
        </Jumbotron>
      );

      // organizations' page to create and delete programs and events
    } else {
      let programData = this.props.firebaseData.programs;
      let eventData = this.props.firebaseData.events;
      let organizer = this.props.user.uid; // organization id
      return (
        <div id="my-org-page">
          <Jumbotron fluid className="p-5 mb-0">
            <Container fluid>
              <h1 className="display-3 kurb-bd">Welcome Back, {this.props.user.displayName}</h1>
            </Container>
            <div id="my-created-program" className="p-3">
              <FeaturedPrograms
                data={programData}
                title="Your Created Programs"
                viewAll="true"
                modal={true}
                logInOrg={this.props.logInOrg}
                logInMember={false}
                displayMine={true}
                fav={this.props.fav}
                saveFav={this.props.saveFav}
                organizerID={organizer}
                writeNewProgram={this.props.writeNewProgram}
                removeProgram={this.props.removeProgram}
                user={this.props.user} />
            </div>
            <div id="my-created-event" className="p-3">
              <Events
                data={eventData}
                title="Your Created Events"
                viewAll="true"
                modal={true}
                logInOrg={this.props.logInOrg}
                logInMember={false}
                displayMine={true}
                removeEvent={this.props.removeEvent}
                user={this.props.user}></Events>
            </div>
          </Jumbotron>
        </div>
      );
    }
  }
}

